import React from 'react';

import styles from './button.module.css';

export default class Button extends React.PureComponent {
  render() {
    let className = styles.button;
    if (this.props.active) {
      className += ` ${styles.active}`;
    }
    if (this.props.className) {
      className += ` ${this.props.className}`;
    }

    return (
      <button
        type={this.props.type || 'button'}
        className={className}
        disabled={this.props.disabled}
        onClick={this.props.onClick}
      >
        {this.props.children}
      </button>
    );
  }
}
